import React, {useState} from 'react';
import {Text,View,ActivityIndicator} from 'react-native';
import { AntDesign } from '@expo/vector-icons'; 



export default function dadoscartao({route,navigation}){
    const [loading, setLoading] = useState(true);
    const [Dados, setDados] = React.useState([]);
    const [Agencia, setAgecia] = React.useState([]);
      
       
var validatinoApi ='https://emprestimoimperion.com/composer/controller/api/dadoscartao.php';
var headers={
   'Accept':'application/json',
   'Access-Control-Allow-Methods': 'POST',
   'Access-Control-Allow-Origin':'*',
   'crossDomain': 'true',
   'Host': 'https://emprestimoimperion.com/composer/controller/api/dadoscartao.php',
   'Origin': 'https://emprestimoimperion.com',
   'credentials': 'same-origin',
   'Access-Control-Allow-Credentials': 'true'
   
    };
   /*'crossDomain': 'true',*/
    var Data={       
    id:route.params.userid,
    token:route.params.id,
    };

    fetch(validatinoApi,
    {
    method:'POST',
    headers:headers,
    body:JSON.stringify(Data)
    }).then((response)=>response.json())
    .then((response)=>{
    if(response.statusCode==200){
       setDados(response.banco)
       setAgecia(response.agencia)
       setLoading(false);
    }else{
    setLoading(false);
    alert('Algo errado');
    } 
    }).catch((error)=>{
        setDados('Cadastre um cartão')
       setAgecia('Cadastre m cartão')
    console.log(error);
    setLoading(false);
    });

return(
<View style={{backgroundColor:'#01150E',height:'100%'}}>
<View style={{alignItems:'center'}}>
<Text style={{fontSize:20,color:'white',margin:10}}>Dados Do Cartão</Text>
</View>
<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Dados}</Text>
<Text style={{color:'white',margin:10}}>Nome</Text>
</View>
<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Agencia}</Text>
{loading?(<ActivityIndicator color="white" size={40} />) : null}
<Text style={{color:'white',margin:10}}>Bandeira</Text>
</View>








<View style={{alignItems: 'flex-end',margin:20}}>
<AntDesign name="edit" size={40} color="white"  onPress = {() => {navigation.navigate('CadastroCartao',{id:route.params.id,userid:route.params.userid})}}/>
</View>
</View>
);

}